document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-atc').forEach((bar) => {
    const sectionId = bar.dataset.section;
    const stickyBtn = bar.querySelector('.sticky-atc__button');
    const stickyPriceEl = bar.querySelector('.sticky-atc__price');
    const infoContainer = document.querySelector(`#ProductInfo-${sectionId}`);

    if (!infoContainer) return;

    // Sticky bar'ı her zaman görünür yap
    bar.classList.add('is-visible');

    // Fiyatı yeniden ID ile arayıp kopyalayan fonksiyon
    const syncPrice = () => {
      const mainPriceEl = document.getElementById(`price-${sectionId}`);
      if (mainPriceEl && stickyPriceEl) {
        stickyPriceEl.innerHTML = mainPriceEl.innerHTML;
      }
    };

    // Butonu yeniden arayıp senkronize eden fonksiyon
    const syncButton = () => {
  const realSubmitBtn = document.querySelector(
    `#ProductInfo-${sectionId} button[name="add"]`
  );
  const textEl = stickyBtn.querySelector('.sticky-atc__button-text');
  if (realSubmitBtn && stickyBtn && textEl) {
    const realIsLoading = realSubmitBtn.classList.contains('loading');
    stickyBtn.disabled = realSubmitBtn.disabled;

    if (!realIsLoading) {
      stickyBtn.classList.remove('is-loading');
      textEl.textContent = realSubmitBtn.textContent.trim();
    }
  }
};

    // İlk yüklemede senkronize et
    syncPrice();
    syncButton();

    // Sticky butona tıklanınca gerçek submit butonunu tetikle
stickyBtn.addEventListener('click', () => {
  const realSubmitBtn = document.querySelector(
    `#ProductInfo-${sectionId} button[name="add"]`
  );
  if (realSubmitBtn && !realSubmitBtn.disabled) {
    stickyBtn.classList.add('is-loading');
    stickyBtn.disabled = true;
    realSubmitBtn.click();
  }
});

    // Tüm ürün bilgi kutusunu izle (fiyat elementi değişse/yenilense bile
    // bu kapsayıcı DOM'da sabit kalır), her değişiklikte yeniden senkronize et
    const observer = new MutationObserver(() => {
      syncPrice();
      syncButton();
    });

    observer.observe(infoContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  });
});